import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map, catchError, startWith } from 'rxjs/operators';
import { Observable, switchMap } from 'rxjs';
import { bearerToken } from './common/auth.service';
import { urls as apis } from './apiUrls';

import { HttpErrorHandler, HandleError } from './common/http-error-handler.service';
import { httpOptions } from './common/common.service';
import { UserSubscriptionModel } from '../models/UserSubscriptionModel';


@Injectable()
export class UserSubscriptionService {	

	private handleError: HandleError;

	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
		this.handleError = httpErrorHandler.createHandleError('SitesService');
	}

	subscribeUser(payload : UserSubscriptionModel): Observable<any> {
		return this.http
			.post(apis.subscribeUser, payload, httpOptions)
			.pipe(catchError(this.handleError('subscribeUser', [])));
	}	
}
